import { ROLES, RoleType } from "./constants"

export function isValidRole(role: string | undefined): role is RoleType {
    return role === ROLES.PSY || role === ROLES.CLIENT
}
